import axios from "@/axios.js";
import MasterFields from "./master_fields_service";

export default {
  getAllMasterFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      MasterFields.getAllMasterFields(item, (rows, lastRow) => {
        // console.log(lastRow);
        resolve({ rows: rows, lastRow: lastRow });
      });
    });
  },
  fetchFields(context, fieldId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/fields/master_fields/${fieldId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeMasterField(context, fieldId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/fields/master_fields/${fieldId}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getExistingFieldLists(context, field_from) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/fields/master_fields/get_existing_field_lists/${field_from}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  searchExistingFieldLists(context, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/master_fields/search_existing_field_lists", {
          item: item
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/master_fields/update_master_field", {
          item: item
        })
        .then(response => {
        
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addFields({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios
        .post("/api/fields/master_fields/add_fields", {
          item: item
        })
        .then(response => {
          // // console.log(response)
          commit(
            "ADD_ITEM",
            Object.assign(item, {
              id: response.data.id
            })
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  removeFields({ commit }, roleId) {
    return new Promise((resolve, reject) => {
      // alert(roleId)
      axios
        .delete(`/api/fields/master_fields/${roleId}`)
        .then(response => {
          commit("REMOVE_STEPS", roleId);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
